import { Outlet, Link } from 'react-router-dom';

const AuthLayout = () => {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-950 flex">
      {/* Left side - Form */}
      <div className="flex-1 flex flex-col justify-center py-12 px-4 sm:px-6 lg:px-20 xl:px-24">
        <div className="mx-auto w-full max-w-sm">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2 mb-8">
            <div className="w-10 h-10 bg-gradient-to-br from-primary-500 to-primary-700 rounded-xl flex items-center justify-center shadow-sm">
              <span className="text-white font-bold text-xl">M</span>
            </div>
            <span className="text-2xl font-bold text-gray-900 dark:text-white">
              MyBank
            </span>
          </Link>

          {/* Page content */}
          <Outlet />
        </div>
      </div>

      {/* Right side - Image/Info */}
      <div className="hidden lg:flex lg:flex-1 bg-primary-600 relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-primary-500 to-primary-700" />
        
        {/* Decorative circles */}
        <div className="absolute top-1/4 -right-20 w-80 h-80 bg-white/10 rounded-full" />
        <div className="absolute bottom-1/4 -left-20 w-60 h-60 bg-white/10 rounded-full" />
        
        <div className="relative z-10 flex flex-col justify-center px-12 text-white">
          <h2 className="text-4xl font-bold mb-4">
            Controle suas finanças de forma simples
          </h2>
          <p className="text-xl text-white/80 mb-8">
            Gerencie suas contas, acompanhe gastos e planeje seu futuro financeiro.
          </p>
          
          <div className="space-y-4">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-white/20 rounded-lg flex items-center justify-center">
                ✓
              </div>
              <span>Dashboard completo com visão geral</span>
            </div>
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-white/20 rounded-lg flex items-center justify-center">
                ✓
              </div>
              <span>Controle de múltiplas contas</span>
            </div>
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-white/20 rounded-lg flex items-center justify-center">
                ✓
              </div>
              <span>Relatórios e projeções</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
